import { render, staticRenderFns } from "./LixsaCancelButton.vue?vue&type=template&id=326e2197&scoped=true"
import script from "./LixsaCancelButton.vue?vue&type=script&lang=js"
export * from "./LixsaCancelButton.vue?vue&type=script&lang=js"
import style0 from "./LixsaCancelButton.vue?vue&type=style&index=0&id=326e2197&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326e2197",
  null
  
)

export default component.exports